import { useCallback, useEffect, useState } from 'react';

export const useAudio = () => {
    const [instance] = useState(new Audio());
    const [isPlaying, setIsPlaying] = useState<number>(-1);

    useEffect(() => {
        const cb = () => {
            setIsPlaying(-1);
        };

        instance.addEventListener('ended', cb);

        return () => {
            instance.removeEventListener('ended', cb);
        };
    }, [instance]);

    const playRudio = useCallback(
        (url, index) => {
            instance.pause();
            if (isPlaying === -1 || isPlaying !== index) {
                instance.src = url;
                instance.play();
                setIsPlaying(index);
            } else {
                setIsPlaying(-1);
            }
        },
        [isPlaying, instance, setIsPlaying]
    );

    return {
        isPlaying,
        playRudio,
    };
};
